import { create } from "../../../../../common/utils/zustand_state_manager";

/**
 * useSaldoBancarioCadastroFilters
 */

type State = {
    idBancoPagamento: number
    idsCentroCusto: number[];
    idsFornecedor: number[];
    idsFuncionario: number[];
    idsSubconta: number[];
    titulo?: string;
    nrConta?: number;
    dataDe?: Date;
    dataAte?: Date;
    tipo: number;
    valor?: number;
};

type Action = {
    setIdBancoPagamento: (v: number) => void,
    setIdsCentroCusto: (list: number[]) => void;
    setIdsFornecedor: (list: number[]) => void;
    setIdsFuncionario: (list: number[]) => void;
    setIdsSubconta: (list: number[]) => void;
    setTitulo: (titulo?: string) => void;
    setNrConta: (nrConta?: number) => void;
    setDataDe: (data?: Date) => void;
    setDataAte: (data?: Date) => void;
    setTipo: (tipo: number) => void;
    setValor: (valor?: number) => void;
    clearFilters: () => void;
};

export const useSaldoBancarioCadastroFilters = create<State & Action>((set) => ({
    idBancoPagamento: 0,
    idsCentroCusto: [],
    idsFornecedor: [],
    idsFuncionario: [],
    idsSubconta: [],
    titulo: undefined,
    nrConta: undefined,
    dataDe: undefined,
    dataAte: undefined,
    tipo: 4,
    valor: undefined,

    setIdBancoPagamento: (idBancoPagamento) => set({ idBancoPagamento }),
    setIdsCentroCusto: (list) => set({ idsCentroCusto: list }),
    setIdsFornecedor: (list) => set({ idsFornecedor: list }),
    setIdsFuncionario: (list) => set({ idsFuncionario: list }),
    setIdsSubconta: (list) => set({ idsSubconta: list }),
    setTitulo: (titulo) => set({ titulo }),
    setNrConta: (nrConta) => set({ nrConta }),
    setDataDe: (dataDe) => set({ dataDe }),
    setDataAte: (dataAte) => set({ dataAte }),
    setTipo: (tipo) => set({ tipo }),
    setValor: (valor) => set({ valor }),

    clearFilters: () =>
        set({
            idsCentroCusto: [],
            idsFornecedor: [],
            idsFuncionario: [],
            idsSubconta: [],
            titulo: undefined,
            nrConta: undefined,
            dataDe: undefined,
            dataAte: undefined,
            tipo: 4,
            valor: undefined,
        }),
}));

export const initialSaldoBancarioCadastrosFiltersValues: State = {
    idBancoPagamento: 0,
    idsCentroCusto: [],
    idsFornecedor: [],
    idsFuncionario: [],
    idsSubconta: [],
    titulo: undefined,
    nrConta: undefined,
    dataDe: undefined,
    dataAte: undefined,
    tipo: 4,
    valor: undefined,

};